import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Link } from '@alfa-bank/site-link';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import { RequestListDesktop as RequestList } from '../request-list/desktop';
import { DefaultItem } from '../request-items/default-item';

import type { TDefaultRequestsDesktop, IDepsDesktop } from './models';
import { DefaultRequests as Component } from './default-requests';

export const DefaultRequestsDesktop = createWidget<IDepsDesktop, TDefaultRequestsDesktop>({
    Link,
    Text,
    RequestList,
    featuredItem: DefaultItem,
    storageItem: DefaultItem,
})(Component);
